import "../components/App/UserMenu.scss";

import React, { useEffect } from "react";
import useLocalStorage from "use-local-storage";

import { fetch_from_ns } from "../utils/axios-utils";
import UserMenu from "/react/components/App/UserMenu";

/**
 * UserMenu sidebar as a react portal
 *
 * This operates without react-router, so it can be used anywhere.
 */
export default function UserMenuPortal() {
  // TODO should validate the menu items and reset if invalid
  const [menu, setMenu] = useLocalStorage("menu", { items: [], name: "" });

  // call the API to get the menu items
  useEffect(() => {
    fetch_from_ns("GET", "/MyNest/menu").then(
      ({ data }) => {
        // bad response?
        setMenu(data);
      },
      (response) => {
        if (process.env.NODE_ENV === "development") {
          console.error("Failed to fetch menu items", response);
        }
        setMenu({ items: [], name: "" });
      },
    );
  }, []);

  if (!menu.items?.length) {
    console.error("No menu items");
    return null;
  }

  return (
    <UserMenu
      menu={menu}
      reactRouter={false}
      currentPath={window.location.pathname}
    />
  );
}
